require('./rokuConnectController');

'use strict';

angular.module('app.rokuConnect', [
    'app.rokuConnect.rokuConnectController'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.rokuConnect', {
                url: '/roku',
                templateUrl: 'components/rokuConnect/rokuConnectView.html',
                controller: 'app.rokuConnect.rokuConnectController',
                fullWidth: true
            });
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/rokuConnect/rokuConnect.js